import { Text } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Pressable, Box } from 'native-base';
import React from 'react';

interface SelectableButtonProps {
  onPress: () => void;
  label: string;
  isSelected: boolean;
}

export const SelectableButton: React.FC<SelectableButtonProps> = ({
  isSelected,
  label,
  onPress,
}) => (
  <Pressable onPress={onPress}>
    <Box
      px={Spacing['inline.nano']}
      py={Spacing['inline.quarck']}
      bg={isSelected ? 'brand.primary.principal' : 'neutral.white'}
      borderRadius={'full'}
      borderWidth={0.3}
      borderColor={'neutral.dark'}>
      <Text
        variant="regular"
        lineHeight="medium"
        textAlign={'center'}
        textTransform={'uppercase'}
        color={isSelected ? 'neutral.white' : 'neutral.dark'}>
        {label}
      </Text>
    </Box>
  </Pressable>
);
